import request from '@/utils/request'
import router from '../../router'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getAdmins: async({ commit, dispatch }, params) => {
        await request({
            method: 'get',
            url: 'account/admin',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                ...params
            }
        }).then(res => {
            if (res.data && res.data.items) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })

                commit('SET_ADMINS', res.data.items)
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.message
            }, { root: true })
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    },

    getAdminById: async({ commit, dispatch }, id) => {
        return request({
            method: 'get',
            url: `account/admin/${id}`
        }).then(res => {
            if (res.data) {
                return res.data
            }
        }).catch(error => {
            if (error.response && error.response.data.code === 404) {
                router.push('/create-account'); return
            }
            dispatch('addMessage', {
                type: 'error',
                message: error.response.message
            }, { root: true })
        })
    },

    updateAdmin: async({ commit, dispatch }, data) => {
        return await request({
            method: 'put',
            url: `account/admin/${data.id}`,
            data
        }).then(res => {
            if (res.data) {
                dispatch('addMessage', {
                    type: 'success',
                    message: 'updated',
                    locale: true
                }, { root: true })
            }
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.data.message
            }, { root: true })
        })
    }
}
